module.exports = __webpack_public_path__ + "assets/74a6fc3517a966f2039ce35c2da45fc2.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/BigWin_1.mp3
 ** module id = 213
 ** module chunks = 0
 **/